import {
  GET_ALL_CAMPAIGNS,
  GET_ALL_CAMPAIGNS_RESPONSE_SUCCESS,
  CREATE_CAMPAIGN,
  UPDATE_CAMPAIGN,
  DELETE_CAMPAIGN,
} from "./actionTypes"

export const getAllCampaigns = () => {
  return {
    type: GET_ALL_CAMPAIGNS,
  }
}
export const getAllCampaignsResponseSuccess = payload => ({
  type: GET_ALL_CAMPAIGNS_RESPONSE_SUCCESS,
  payload: payload,
})

// ------------------------------------- CREATE --------------------------------------------------------

export const createCampaign = (payload, history) => {
  return {
    type: CREATE_CAMPAIGN,
    payload: payload,
    history,
  }
}

// ------------------------------------- EDIT --------------------------------------------------------

export const updateCampaign = (payload, history, id) => {
  return {
    type: UPDATE_CAMPAIGN,
    payload: payload,
    history,
    id,
  }
}

// ------------------------------------- DELETE --------------------------------------------------------

export const deleteCampaign = payload => ({
  type: DELETE_CAMPAIGN,
  payload: payload,
})
